<template>
    <BasePanel :alvqa="alvqa" headline="lang_PUBLISHING_WORKS_CAPTION_OTHER_TITLES">
        <template v-slot:panelContent>
            <v-data-table         
                :headers="headers"
                hide-default-footer
                :items="item"
                :no-data-text="$t('lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')"
                class="noMinWidth"
                :items-per-page="itemsPerPage"
            >
                <!-- alvqas for headers -->
                <template v-for="(header, i) in headers" v-slot:[`header.${header.value}`]>
                    <span :alvqa="header.alvqa" :key="i">{{ header.text }}</span>
                </template>

                <template v-slot:[`item.title`]="{ item }">
                    <div :alvqa="alvqa +'-list-row-' + item.type + '-text-type'">
                        {{ item.title }}
                    </div>
                </template>
                <template v-slot:[`item.type`]="{ item }">
                    <div :alvqa="alvqa +'-list-row-' + item.type + '-text-type'">
                        {{ $t(getType(item.type)) }}
                    </div>
                </template>
            </v-data-table>
        </template>
    </BasePanel>
</template>

<script>
import BasePanel from '@/components/_base/BasePanel'
import { DropdownPublishingWorksAlternativeTitleTypes } from '@/assets/dropdowns/alvDropdowns.js'

export default {
    name: "WorkOtherTitlesPanel",
    components: {
        BasePanel
    },
    props:{
        workAlvId: {
            type: String
        }
    },
    data() {
        return {
            alvqa: 'publishing-works-list-row-' + this.workAlvId + '-read-only-panel-other-titles'
        }
    },
    computed: {
        item() {
            let item = this.$store.getters.getExpandedWorks.find(element => {
                return element.alvId === this.workAlvId
            }) 
            let alternativeTitles = item.alternativeTitles === null ? [] : item.alternativeTitles
            return alternativeTitles
        },
        headers() {
            return [
                {
                    text: this.$t("lang_PUBLISHING_WORKS_CAPTION_WORK_TITLE"), 
                    align: "left", 
                    value: "title",
                    sortable: false,
                    alvqa: this.alvqa + '-header-work-title'
                },
                {
                    text: this.$t("lang_PUBLISHING_WORKS_CAPTION_TYPE"), 
                    align: "left", 
                    value: "type",
                    sortable: false,
                    alvqa: this.alvqa + '-header-type'
                }
            ]
        },
        
        itemsPerPage() { return this.$store.getters.getItemsPerPage },
    },
    methods: {
        getType(value) {
            return DropdownPublishingWorksAlternativeTitleTypes.find(type => {
                return type.value === value
            }).text
        }
    }
    
}
</script>

<style>
    .noMinWidth table {
        min-width: 0px !important;
    }
</style>